module.exports = __webpack_public_path__ + "static/media/LockOn.00118dea.svg";